import { Dispatch, SetStateAction } from 'react';
import { TreeSelectProps } from 'antd';

import { commonStore } from 'stores';
import { useGetRequest, useMemoState } from 'hooks';

import { DisplayCompaniesResponse, DisplayCompany } from 'codegen';

export const useGetCompanies = (withRetailers?: boolean):
[{ companies?: DisplayCompany[], loading: boolean; }, Dispatch<SetStateAction<DisplayCompany[] | undefined>>] => {
  const user = commonStore((state) => state.user);

  const [companies, setCompanies] = useMemoState<DisplayCompany[]>();

  const { loading } = useGetRequest<DisplayCompaniesResponse>({
    url: withRetailers ? '/companies?includeRetailers=true' : '/companies?sort=id,desc',
    options: {
      ready: !!user,
      onSuccess: ({ data }) => {
        if (withRetailers) {
          const companiesTree = data.companies.reduce<TreeSelectProps['treeData']>((acc, item) => {
            if (item.retailers?.length) {
              acc?.push({
                value: item.id,
                title: item.englishName,
                children: item.retailers?.map(({ name, id }) => ({ title: name, value: `${id}-${item.id}` })),
              });
            }

            return acc;
          }, []);

          return setCompanies(companiesTree as DisplayCompany[]);
        }

        return setCompanies(data.companies as DisplayCompany[]);
      },
    },
  });

  return [{ companies, loading }, setCompanies];
};
